/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon20Light = forwardRef('ArrowDUturnLeftDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 9.5a6.5 6.5 0 1 1 13 0v4a.5.5 0 1 1-1 0v-4a5.5 5.5 0 1 0-11 0v6.34a.764.764 0 0 0 .057-.057l3.571-3.967a.5.5 0 0 1 .744.668L6.8 16.453a1.75 1.75 0 0 1-2.602 0L.63 12.484a.5.5 0 1 1 .743-.668l3.57 3.967c.019.02.038.04.058.058V9.5Z" })));
});
